module.exports = __webpack_public_path__ + "images/6d3b33ac114a294f478a832eb2d0a551-edit_icon.png";